import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ContactService, ContactFilter } from "../../services/contacts.service";
import { HttpService } from "../../services/http.service";
import { ActivatedRoute } from "@angular/router";
import { BsModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { DateUtility } from "../../util/date.utility";
import { AppSettings } from '../../app.settings';
import { StringUtility } from "../../util/string.utility";
import { AgentUtility } from "../../util/agent.utility";
import { EventsService } from "../../services";
import { MeetingsService } from '../../services/meetings.service';

@Component({
    selector: 'app-person',
    templateUrl: './person.component.html',
    providers: [ContactService, EventsService]
})
export class PersonComponent implements OnInit {

    contracts: any;
    @ViewChild('modalPerson_l012',{static: false}) modalPerson_l012: BsModalComponent;
    @ViewChild('modalPerson_l013',{static: false}) modalPerson_l013: BsModalComponent;
    @ViewChild('modalPerson_l014',{static: false}) modalPerson_l014: BsModalComponent;
    showLoadScreen: boolean;
    AllDone: boolean = false;
    meetings:any[];
    private CurrentId: number;

    constructor(private Service: ContactService,
        private activeRoute: ActivatedRoute,
        private _location: Location,
        private eventService: EventsService,
        private _meettingsService:MeetingsService) {
        this.Service.onStart = this.eventService.onStart = () => this.showLoadScreen = true;
        this.Service.onEnd = this.eventService.onEnd = () => this.showLoadScreen = false;
        this.CurrentId = AgentUtility.getUser().Id;
    }

    splited(phone) {
        if (phone != null && phone != "")
            return phone.split(',');
    }

    ngOnInit() {
        var id = this.activeRoute.snapshot.params['id'];
        this.getMeetings(id);
        this.Service.getPersonInfo(this.CurrentId, id).subscribe((data) => {

            this.AllDone = data.status != "ERROR";
            if (this.AllDone) {
                this.contracts = data.data;
                this.contracts = this.contracts.map((x) => {
                    x.showEvents = false;
                    let check = x.v_Events.filter(x => x.IsViewed == false);
                    if (check.length == 0)
                        x.showEvents = false;
                    else
                        x.showEvents = true;
                    return x;
                });
                if(this.contracts.length > 0){
                    let fio:string[] = this.contracts[0].PolicyHolder.split(" ");
                    let phones = this.contracts[0].PolicyHolderPhone;
                }
            } else if (data.code == 1013) {
                this.modalPerson_l013.open();
            } else if (data.code == 1012) {
                this.modalPerson_l012.open();
            } else if (data.code == 1014) {
                this.modalPerson_l014.open();
            }
        });
    }

    closeModal() {
        this._location.back();
    }
    eventPink(event) {
        var currentDate = new Date();
        return (event.EventTypeId == 2 && new Date(event.EventDate).getTime() < currentDate.getTime()) && !(event.Amount != null && (event.DocumentStatusId == 6 || event.DocumentStatusId == 463)) ? "client-full__item_pink" : "client-full__item";
    }
    toggleLoadScreen() {
        this.showLoadScreen = !this.showLoadScreen;
    }


    toggleEvents(contract) {
        contract.showEvents = !contract.showEvents;
    }

    getMeetings(id){
        let agentId = AgentUtility.getUser().Id;
        this._meettingsService.getPersonMeetings(agentId,id).subscribe(data =>{
            this.meetings = data.data;
        })
    }

    getMeetingsWithoutContract(){
        return this.meetings.filter(m => !m.meeting.PolicyNum)
    }

    getMeetingsByContract(contractId){
        return this.meetings.filter(m => m.meeting.PolicyNum == contractId)
    }

    getMeetingColor(result:string):string{
        let color = ""
        switch(result){
            case "Продажа":
                color = "#ff1e00";
            break
            case "В обработке":
                color = "#ff1e00";
            break
            case "Отказ":
                color = "#F5B81A";
            break
            case "Назначение повторной встречи":
                color = "#ff1e00";
            break
            default:
                color = "#48ab17"
            break
        }
        return color;
    }

    
    getMeetingImage(result:string):string{
        let image = ""
        switch(result){
            case "Продажа":
                image = "../../assets/img/icon-doc-fail.png";
            break
            case "В обработке":
                image = "../../assets/img/icon-doc-fail.png";
            break
            case "Отказ":
                image = "../../assets/img/icon-doc-fail.png";
            break
            case "Назначение повторной встречи":
                image = "../../assets/img/icon-doc-fail.png";
            break
            default:
                image = "../../assets/img/success_doc_icon.png"
            break
        }
        return image;
    }

    getPhone(phone:string):string{
        if(!phone)
          return "";
        if(phone == "")
          return "";
        let type:string = phone.length < 3? "SHORT" : phone.length == 3? "MIDDLE" : "LONG";
        let result:string;
        switch(type){
          case "SHORT":
            result = `+7 (${phone.slice(0,phone.length)}`;
            break;
          case "MIDDLE":
            result = `+7 (${phone.slice(0,3)})`;
            break;
          case "LONG":
            let middleCode = phone.slice(3,6);
            let endCode = phone.length >= 6? phone.slice(6) : "";
            result = endCode == "" ? `+7 (${phone.slice(0,3)}) ${middleCode}` : `+7 (${phone.slice(0,3)}) ${middleCode} ${endCode}`;
            break;
        }
        return result;
      }

    seeEvent(event) {
        // 
        let changeObj = {};
        if (event.IsViewed) {
            changeObj = {
                Id: event.Id,
                IsViewed: !event.IsViewed,
                ViewedByAgentId: null
            }
        } else {
            changeObj = {
                Id: event.Id,
                IsViewed: !event.IsViewed,
                ViewedByAgentId: AgentUtility.getLocalUser().Id
            }
        }
        this.eventService.changeEvent(changeObj).subscribe((data) => {
            event = Object.assign(event, data.data);
        });
        //event.IsViewed = !event.IsViewed;
    }

    showEvents(contract) {
        let filters = contract.v_Events.filter(x => x.IsViewed == false);
        if (filters.length == 0)
            return false;
        else
            return true;
    }

    diffDate(end, start): number {
        return DateUtility.diffDate(end, start);
    }

    public getPaymentUrl(contract): string {
        return `portfolio/${contract.ContractHeaderId}`;
    }

    getColorStatus(StatusId) {
        var notRedStatuses = [19, 2, 91, 441, 20, 1, 89];
        if (notRedStatuses.indexOf(StatusId) == -1) {
            return 'red';
        } else {
            return 'black';
        }
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }
}
